// AUTO-GENERATED by scripts/gen-version.mjs — do not edit by hand.
export const APP_VERSION = "0.9.10d" as const;
export const COMMIT_SHA = "82a94ae" as const;
export const BUILD_TIME = "2026-11-05T06:31:46.515Z" as const;
